import { Button } from "@/components/ui/button";

const Benefits = () => {
  return (
    <section id="benefits" className="section-padding bg-gradient-to-b from-gray-50 to-white relative overflow-hidden">
      {/* Parallax elements */}
      <div className="absolute top-1/4 left-0 h-72 w-72 bg-taxby-purple/10 rounded-full -z-10 animate-float" style={{ animationDelay: '0.5s' }}></div>
      <div className="absolute bottom-10 right-10 h-40 w-40 bg-taxby-orange/10 rounded-full -z-10 animate-float" style={{ animationDelay: '1.2s' }}></div>
      
      <div className="container mx-auto">
        <div className="text-center mb-16">
          <span className="block text-taxby-purple font-semibold mb-4">Beneficios para autónomos que venden online</span>
          <h2 className="text-3xl md:text-4xl font-bold text-taxby-violet mb-6">
            Diseñado especialmente para profesionales que operan en plataformas como Amazon, Shopify, Etsy, Miravia, entre otras.
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-12 gap-y-20 items-center">
          {/* First benefit block */}
          <div className="order-2 lg:order-1">
            <div className="mb-8">
              <h3 className="text-2xl font-semibold text-taxby-violet mb-4">Integración con plataformas de venta online</h3>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start">
                  <span className="text-taxby-purple mr-2">✓</span>
                  <span>Clasificación automática de ingresos por canal</span>
                </li>
                <li className="flex items-start">
                  <span className="text-taxby-purple mr-2">✓</span>
                  <span>Control de IVA en operaciones nacionales e intracomunitarias</span>
                </li>
                <li className="flex items-start">
                  <span className="text-taxby-purple mr-2">✓</span>
                  <span>Facturación adaptada al comercio electrónico</span>
                </li>
                <li className="flex items-start">
                  <span className="text-taxby-purple mr-2">✓</span>
                  <span>Informes personalizados por plataforma de venta</span>
                </li>
              </ul>
            </div>
          </div>
          
          <div className="order-1 lg:order-2">
            <div className="relative">
              <img 
                src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1200&q=80" 
                alt="Integración con plataformas de venta online" 
                className="rounded-xl shadow-xl w-full h-auto"
                loading="lazy"
              />
              <div className="absolute -bottom-5 -right-5 bg-taxby-purple/20 w-full h-full rounded-xl -z-10"></div>
            </div>
          </div>
          
          {/* Second benefit block */}
          <div className="order-3">
            <div className="relative">
              <img 
                src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1200&q=80" 
                alt="Control de finanzas" 
                className="rounded-xl shadow-xl w-full h-auto"
                loading="lazy"
              />
              <div className="absolute -bottom-5 -left-5 bg-taxby-purple/20 w-full h-full rounded-xl -z-10"></div>
            </div>
          </div>
          
          <div className="order-4">
            <div className="mb-8">
              <div className="inline-flex items-center justify-center h-12 w-12 rounded-full bg-taxby-purple text-white text-xl font-bold mb-4">2</div>
              <h3 className="text-2xl font-semibold text-taxby-violet mb-4">Control total de tus finanzas</h3>
              <p className="text-gray-600 mb-4">Lleva toda la contabilidad de un vistazo con gastos e ingresos perfectamente organizados.</p>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start">
                  <span className="text-taxby-purple mr-2">✓</span>
                  <span>Seguimiento de gastos e ingresos</span>
                </li>
                <li className="flex items-start">
                  <span className="text-taxby-purple mr-2">✓</span>
                  <span>Integración con plataformas de venta online</span>
                </li>
                <li className="flex items-start">
                  <span className="text-taxby-purple mr-2">✓</span>
                  <span>Informes personalizados</span>
                </li>
              </ul>
            </div>
          </div>
          
          {/* Third benefit block */}
          <div className="order-6 lg:order-5">
            <div className="mb-8">
              <div className="inline-flex items-center justify-center h-12 w-12 rounded-full bg-taxby-orange text-white text-xl font-bold mb-4">3</div>
              <h3 className="text-2xl font-semibold text-taxby-violet mb-4">Interfaz intuitiva y fácil de usar</h3>
              <p className="text-gray-600 mb-4">Un entorno seguro, fácil e intuitivo para que gestionar tu contabilidad sea una tarea sencilla.</p>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start">
                  <span className="text-taxby-orange mr-2">✓</span>
                  <span>Diseño centrado en el usuario</span>
                </li>
                <li className="flex items-start">
                  <span className="text-taxby-orange mr-2">✓</span>
                  <span>Rápido aprendizaje y uso</span>
                </li>
                <li className="flex items-start">
                  <span className="text-taxby-orange mr-2">✓</span>
                  <span>Notificaciones inteligentes</span>
                </li>
              </ul>
              <Button 
                onClick={() => document.getElementById('subscribe')?.scrollIntoView({ behavior: 'smooth' })}
                className="bg-taxby-orange hover:bg-taxby-orange/90 text-white mt-6"
              >
                Únete a la lista de espera
              </Button>
            </div>
          </div>
          
          <div className="order-5 lg:order-6">
            <div className="relative">
              <img 
                src="https://images.unsplash.com/photo-1553877522-43269d4ea984?auto=format&fit=crop&w=1200&q=80" 
                alt="Interfaz intuitiva de Taxby" 
                className="rounded-xl shadow-xl w-full h-auto"
                loading="lazy"
              />
              <div className="absolute -bottom-5 -right-5 bg-taxby-orange/20 w-full h-full rounded-xl -z-10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
